import React from 'react'
import DisplayHtml from 'src/components/Forms/RichTextEditor/DisplayHtml'
import { useDistributionSubcategoryNotesById } from 'src/queries'

interface BodyProps {
  id: string
}

const Body: React.FC<BodyProps> = (props) => {
  const { id } = props
  const distributionSubcategory = useDistributionSubcategoryNotesById(id)
  return (
    <DisplayHtml value={distributionSubcategory?.notes ?? ''} />
  )
}

export default Body
